export default __webpack_public_path__ + "static/Pulizie-Uffici-Manutenpul-471adb3b1ca1ee6c379fa85a57d39552.webp";